module.exports = __webpack_public_path__ + "img/space.07e18e39.gif";